<script setup lang="ts">
import { useRouter } from 'vue-router'

import UigIcon from '@/components/UigIcon.vue'
import { useGenerationsStore, type GenerationToast } from '@/stores/generations'

const router = useRouter()
const generations = useGenerationsStore()

async function openPlans(toast: GenerationToast) {
  generations.dismissToast(toast.id)
  await router.push('/plans')
}
</script>

<template>
  <TransitionGroup
    tag="div"
    name="generation-toast"
    class="generation-toasts"
    role="status"
    aria-live="polite"
  >
    <div
      v-for="toast in generations.toasts"
      :key="toast.id"
      class="generation-toast"
      :class="`generation-toast--${toast.kind}`"
    >
      <UigIcon
        :name="toast.kind === 'ready' ? 'check_mark_circled_solid' : toast.kind === 'stalled' ? 'time' : 'xmark'"
        :size="18"
      />
      <span>{{ toast.message }}</span>
      <button
        v-if="toast.kind === 'ready'"
        class="generation-toast__open"
        type="button"
        @click="generations.openViewer(toast.generationId)"
      >
        Open
      </button>
      <button
        v-else-if="toast.kind === 'payment'"
        class="generation-toast__open"
        type="button"
        @click="openPlans(toast)"
      >
        Get credits
      </button>
      <button
        class="generation-toast__dismiss"
        type="button"
        aria-label="Dismiss"
        @click="generations.dismissToast(toast.id)"
      >
        <UigIcon
          name="xmark"
          :size="14"
        />
      </button>
    </div>
  </TransitionGroup>
</template>
